<app-navbar title="Lista rezerwacji"> </app-navbar>
<section>
	<div class="ms-3 me-3 mt-3">
		<mat-accordion multi>
			<mat-expansion-panel [(expanded)]="expandedPanel">
				<mat-expansion-panel-header>
					<mat-panel-title
						><i class="fa fa-filter"></i><span class="ms-2 font-wegiht-700">Filtry</span></mat-panel-title
					>
				</mat-expansion-panel-header>
				<app-bag-reservation-list-filter
					userFilters="reservationList"
					[forceFilters]="{ limit: 9999 }"
					[locations]="parameters.filtersLocations"
					[destinations]="parameters.locations"
					[products]="parameters.products"
					[productKinds]="parameters.productKind"
					[transportStops]="parameters.transportStops"
					[status]="parameters.filterStatus"
					[paymentStatus]="parameters.paymentStatus"
					[users]="parameters.allUsers"
					[roomTypes]="parameters.roomTypes"
					[organizations]="parameters.organizations"
					[channels]="parameters.channels"
					[alerts]="parameters.alerts"
					[services]="parameters.services"
					[seasons]="parameters.seasons"
					[agencies]="parameters.agencies"
					[paymentKinds]="parameters.paymentsKinds"
					(displayStat)="statisticLoadBefore($event)"
					(selected)="filtersSelected($event)"
				></app-bag-reservation-list-filter>
			</mat-expansion-panel>
			<span *ngIf="statistic">
				<mat-expansion-panel>
					<mat-expansion-panel-header>
						<mat-panel-title
							><i class="fa-solid fa-chart-simple"></i>
							<span class="ms-2 font-wegiht-700">Statystyki</span>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<app-bag-reservation-list-statistic [data]="dataStatistic"></app-bag-reservation-list-statistic>
				</mat-expansion-panel>
			</span>
		</mat-accordion>
	</div>
	<div class="pb-6 overflow ps-3 pe-3">
		<app-bag-reservation-list-table
			[allItemsSize]="allItemsSize()"
			[filters]="filters"
			[parameters]="parameters"
			[elements]="data"
			[columns]="tableColumnsDef"
			(page)="pageChanged($event)"
			(sortedByColumn)="sortBy($event)"
		></app-bag-reservation-list-table>
	</div>
</section>

@if (loading()) {
	<div class="loader">
		<mat-spinner></mat-spinner>
	</div>
}
